import React, { useContext, useEffect } from "react";
import { AttempsContext } from "../context/AttemptsContext";
import { CoursesContext } from "../context/CoursesContext";
import QuizQuestion from "./QuizQuestion";
import QuizResult from "./QuizResult";

const SingleAttempt = ({ attempt_id }) => {
  const {
    update,
    spinner,
    attempt,
    answers,
    questions,
    setAnswer,
    setUpdate,
    clearAttempt,
    saveUserAnswer,
    getSingleAttempt,
  } = useContext(AttempsContext);
  const { getCourse } = useContext(CoursesContext);

  useEffect(() => {
    clearAttempt();
    getSingleAttempt(attempt_id);
    return clearAttempt;
  }, [attempt_id]);

  useEffect(() => {
    if (update) {
      getSingleAttempt(attempt_id);
      setUpdate(false);
    }
  }, [update]);

  useEffect(() => {
    if (attempt !== null) {
      if (attempt.test && attempt.test !== null) {
        // A quiz hangs off a section; a final exam points at the course directly.
        const { section, course_id } = attempt.test;
        if (section && section !== null) {
          getCourse(section.course_id);
        } else if (course_id !== null && course_id !== undefined) {
          getCourse(course_id);
        }
      }
    }
  }, [attempt]);

  const handleCallback = () => getSingleAttempt(attempt_id);

  const renderQuestion = () => {
    if (attempt && attempt !== null) {
      if (attempt.finishedAt !== null) {
        return <QuizResult />;
      }
    }
    if (Array.isArray(questions) && Array.isArray(answers)) {
      return (
        <QuizQuestion
          spinner={spinner}
          attempt={attempt}
          questions={questions}
          setAnswer={setAnswer}
          user_answers={answers}
          attempt_id={attempt_id}
          handleCallback={handleCallback}
          saveUserAnswer={saveUserAnswer}
        />
      );
    }
  };

  return (
    <div className="d-flex flex-column flex-grow-1 w-100 single-attempt-route">
      {renderQuestion()}
    </div>
  );
};

export default SingleAttempt;
